import { Button, message, Modal, Space, Spin, Typography } from 'antd';
import React, { useState } from 'react';

const { Paragraph } = Typography;
const DisableEnableTagModal = ({ onDisableEnableTag, loading, disabled }) => {
  const [isModalDisableVisible, setIsModalDisableVisible] = useState(false);
  const [isModalEnableVisible, setIsModalEnableVisible] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);

  const handleEnableDisableTag = async (toArchive) => {
    setIsProcessing(true);
    try {
      await onDisableEnableTag(toArchive);
      message.success(toArchive ? 'Tag Archived Successfully' : 'Tag Unarchived Successfully');
    } catch (error) {
      message.error(toArchive ? 'Error Archiving Tag' : 'Error Unarchiving Tag');
    } finally {
      setIsProcessing(false);
    }
    if (toArchive) {
      setIsModalDisableVisible(false);
    } else {
      setIsModalEnableVisible(false);
    }
  };

  return (
    <React.Fragment>
      <Modal
        title="ARCHIVE TAG"
        wrapClassName="tags-modal"
        visible={isModalDisableVisible}
        onCancel={() => setIsModalDisableVisible(false)}
        closable={!isProcessing}
        maskClosable={!isProcessing}
        footer={
          <Space>
            <Button
              type="primary"
              loading={isProcessing}
              disabled={isProcessing}
              onClick={() => {
                handleEnableDisableTag(true);
              }}
            >
              Archive
            </Button>
            <Button type="default" onClick={() => setIsModalDisableVisible(false)} disabled={isProcessing}>
              Cancel
            </Button>
          </Space>
        }
      >
        <Spin spinning={isProcessing}>
          <Paragraph>Archiving a tag will hide it from your tag options.</Paragraph>
        </Spin>
      </Modal>
      <Modal
        title="UNARCHIVE TAG"
        wrapClassName="tags-modal"
        visible={isModalEnableVisible}
        onCancel={() => setIsModalEnableVisible(false)}
        closable={!isProcessing}
        maskClosable={!isProcessing}
        footer={
          <Space>
            <Button
              type="primary"
              loading={isProcessing}
              disabled={isProcessing}
              onClick={() => {
                handleEnableDisableTag(false);
              }}
            >
              Unarchive
            </Button>
            <Button type="default" onClick={() => setIsModalEnableVisible(false)} disabled={isProcessing}>
              Cancel
            </Button>
          </Space>
        }
      >
        <Spin spinning={isProcessing}>
          <Paragraph>Unarchiving a tag will make it available for selection again.</Paragraph>
        </Spin>
      </Modal>
      <Button
        shape="round"
        type="default"
        loading={loading}
        hidden={!disabled}
        onClick={() => setIsModalEnableVisible(true)}
      >
        Unarchive Tag
      </Button>
      <Button
        shape="round"
        type="primary"
        hidden={disabled}
        loading={loading}
        onClick={() => setIsModalDisableVisible(true)}
      >
        Archive Tag
      </Button>
    </React.Fragment>
  );
};

export default DisableEnableTagModal;
